import React, { useState } from "react";
import SearchView from "../ui/SearchView";
import LanguageSwitcher from "LanguageSwitcher";
import { useTranslation } from "react-i18next";

const Header2 = ({ pageTitle }) => {

  const {t} = useTranslation();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full bg-header-background px-4 sm:px-6 lg:px-6 py-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 w-full">
        <h1 className="text-xl sm:text-2xl font-bold text-text-accent">
          {t(pageTitle)}
        </h1>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full sm:w-auto">
          {/* Search */}
          <div className="flex-1 sm:flex-none w-full sm:w-[400px]">
            <div className="relative">
              <input
                type="text"
                placeholder={t("search_hint")}
                className="w-full px-8 py-2 text-base bg-secondary-light rounded-2xl border-none outline-none text-background-overlay"
              />
              <img
                src="/images/img_search_gray_600.svg"
                alt="Search"
                className="absolute right-4 top-1/2 transform -translate-y-1/2 w-6 h-6"
              />
            </div>
          </div>

          {/* Right Icons */}
          <div className="flex items-center gap-5">
           {/* <img
              src="/images/img_bell_outline.svg"
              alt="Notifications"
              className="w-6 h-6 cursor-pointer hover:opacity-80"
            />*/}
            <LanguageSwitcher />
            <img
              src="/images/img_17_picture.png"
              alt="Profile"
              className="w-10 h-10 rounded-full cursor-pointer"
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header2;
